"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsx jsx */
const react_1 = require("@emotion/react");
const b_1 = __importDefault(require("b_"));
const i18n_1 = __importDefault(require("@yandex-int/pythia-libs/lib/i18n"));
const settings_1 = require("src/hooks/settings");
const branding_1 = require("src/context/branding");
const input_1 = __importDefault(require("src/components/input"));
const question_1 = __importDefault(require("src/components/question"));
const plug_1 = __importDefault(require("src/components/plug"));
const question_text_styles_1 = __importDefault(require("./question-text.styles"));
const b = b_1.default.with('question-text');
const inputTypes = {
    email: 'email'
};
// eslint-disable-next-line complexity
function Text(props) {
    var _a;
    const { id = 0, value = '', children, handleChange = () => { }, handleBlur = () => { }, type, postfix } = props, rest = __rest(props, ["id", "value", "children", "handleChange", "handleBlur", "type", "postfix"]);
    const placeholder = usePlaceholder(type, postfix);
    const charLimits = (0, settings_1.useCharLimits)();
    const inputType = (_a = inputTypes[type]) !== null && _a !== void 0 ? _a : 'text';
    return ((0, jsx_runtime_1.jsxs)(question_1.default, Object.assign({}, rest, { type: type, id: id }, { children: [(0, jsx_runtime_1.jsx)(react_1.Global, { styles: question_text_styles_1.default }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: `${b('input-wrap')} ${type}` }, { children: [(0, jsx_runtime_1.jsx)(input_1.default, { "data-index": id, size: 'dependent', type: inputType, value: value, textArea: type === 'longText', placeholder: placeholder, onBlur: handleBlur, onChange: handleChange }), (0, jsx_runtime_1.jsx)(plug_1.default, { current: value.length, max: charLimits[type] }), postfix && (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('postfix') }, { children: postfix }))] })), children] })));
}
exports.default = Text;
function usePlaceholder(type, postfix) {
    const i18n = (0, i18n_1.default)(['placeholders']);
    const { input: { placeholders = {} } = {} } = (0, branding_1.useBrandingContext)() || {};
    const placeholdersWithDefaults = Object.assign({
        email: 'example@mail.com',
        longText: i18n(['longText']),
        number: '1234567890',
        percent: '',
        shortText: i18n(['shortText']),
        date: '',
        geoText: ''
    }, placeholders);
    return postfix === '%' ? placeholdersWithDefaults.percent : placeholdersWithDefaults[type];
}
